module.exports = __webpack_public_path__ + "img/h1.6474f320.png";